import { get } from 'src/utils/networkUtils';

/**
 * Read-only breakdown of what the gameweek-lock transition did (transfers,
 * substitutions, captaincy, budgets) - shown on the App Settings page next to
 * the gameplay toggles. Pass a gameweekId to inspect a specific gameweek;
 * omit it for the most recent one that has locked.
 */
export async function getGameweekTransitionStatus(gameweekId) {
  const query = gameweekId ? `?gameweekId=${encodeURIComponent(gameweekId)}` : '';
  const body = await get(`/admin/gameweek-transition/status${query}`);
  return body?.data ?? null;
}
